import { createIcon } from "@chakra-ui/react";

export const Edit = createIcon({
  displayName: "Edit",
  viewBox: "0 0 24 24",
  d: "M18.89 4.519a1.767 1.767 0 0 0-2.5 0l-.95.947 3.091 3.091.95-.95a1.767 1.767 0 0 0 0-2.501l-.59-.587zm-9.446 6.946c-.193.193-.341.43-.427.692l-.934 2.804a.762.762 0 0 0 .183.776.752.752 0 0 0 .777.184l2.804-.935c.258-.089.495-.234.691-.426l5.282-5.286-3.094-3.095-5.282 5.286zM7.03 5.855A3.032 3.032 0 0 0 4 8.884v8.084A3.032 3.032 0 0 0 7.031 20h8.083a3.032 3.032 0 0 0 3.032-3.031v-3.032a1.01 1.01 0 1 0-2.021 0v3.032a1.01 1.01 0 0 1-1.01 1.01H7.03a1.01 1.01 0 0 1-1.01-1.01V8.885c0-.558.451-1.01 1.01-1.01h3.032a1.01 1.01 0 1 0 0-2.02H7.03z",
  defaultProps: {
    "aria-label": "A pencil within a square"
  }
});

export default Edit;
